import { apiRequest, downloadFile } from "./apiClient";

function base(transactionId) {
  return `/api/transactions/${transactionId}/attachments`;
}

export function listReceipts(transactionId) {
  return apiRequest(base(transactionId));
}

export function uploadReceipt(transactionId, file) {
  const body = new FormData();
  body.append("file", file);
  return apiRequest(base(transactionId), { method: "POST", body });
}

export function deleteReceipt(transactionId, attachmentId) {
  return apiRequest(`${base(transactionId)}/${attachmentId}`, { method: "DELETE" });
}

export function downloadReceipt(transactionId, attachmentId) {
  return downloadFile(`${base(transactionId)}/${attachmentId}`);
}

